<template>
    <div class="custom-box h-100 mb-0">
        <div class="mt-3">
            <div class="leave-req-wrapper">
                <div class="content-div-title mb-3 mt-4">Most Recent Leave Log <i class="small font-weight-normal">(Last 5 applications)</i> </div>
                <template v-if="count_leaves > 0">
                    <table class="">
                        <thead>
                            <tr class="table-head">
                                <th class="cursor-pointer" v-for="column in columns" :key="column.name" @click="sortBy(column.name)">{{column.label}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="table-row" v-for="(leave,n) in leaves" :key="n" v-if="n < 5">
                                <td class="font-semi-bold">
                                    <b-icon :icon="leave.icon || 'calendar'" class="mr-2 text-primary" font-scale="1.1"></b-icon>
                                    {{leave.leave_type}}
                                </td>
                                <td class="text-center font-semi-bold">{{leave.from}}</td>
                                <td class="text-center font-semi-bold">{{leave.to}}</td>
                                <td class="text-left font-semi-bold">
                                    <template v-if="leave.leave_day == 0">
                                        {{leave.number_of_days}}
                                        <span v-if="leave.number_of_days > 1">days</span>
                                        <span v-else>day</span>
                                    </template>
                                    <template v-else-if="leave.leave_day == 1">First Half</template>
                                    <template v-else-if="leave.leave_day == 2">Second Half</template>
                                </td>
                                <td class="text-center font-semi-bold" :class="leave.status.toLowerCase()">
                                    <span class="leave-status" v-if="leave.status == 'Applied'"><i
                                            class="fa fa-circle mr-1"></i>Pending</span>
                                    <span class="leave-status" v-if="leave.status == 'Approved'"><i
                                            class="fa fa-circle mr-1"></i>{{leave.status}}</span>
                                    <span class="leave-status" v-if="leave.status == 'Declined'"><i
                                            class="fa fa-circle mr-1"></i>{{leave.status}}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </template>
                <template v-else>
                    No Leave Request Found.
                </template>
            </div>
        </div>
    </div>
</template>
<script>
    let sortOrders = {};
    let columns = [

        {
            label: 'Leave Category',
            name: 'leave_type'
        },
        {
            label: 'From',
            name: 'from'
        },
        {
            label: 'To',
            name: 'to'
        },
        {
            label: 'No. of Days',
            name: 'number_of_days'
        },
        {
            label: 'Status',
            name: 'status'
        },

    ];
    export default {
        data() {
            return {
                leaves: [],
                leavetypes: [],
                img_src: this.$api_url + '/images/employee_dasboard/',
                page: {
                    month: '',
                    year: ''
                },
                columns: columns,
                sortOrders: sortOrders,
                leaves: [],
                count_leaves: 0,
                cr: 0,
                page: {
                    month: '',
                    year: ''
                },
                img_src: this.$api_url + '/images/employee_dasboard/',
            };
        },
        methods: {


            getRecentLeaves: function () {
                if (!this.checkNet()) return false;

                this.employee_id = 0;
                let currentObj = this;
                axios.get(this.$api_url + '/front/leave-attendance/employee/leaves/year', {
                    params: {
                        flg: 1
                    }
                }).then(function (response) {
                    this.leaves = response.data.leaves;
                    this.count_leaves = response.data.leaves.length;
                    console.log(this.count_leaves);

                }.bind(this)).catch(function (error) {
                    currentObj.serverError(error);
                });
            },

            setMe: function (x) {


                if (x == 'request-leave')
                    this.$bvModal.show('bv-modal-leave');
                else {
                    let childdata = {
                        component_name: x
                    };
                    this.$emit('childToParent', childdata);
                }

            },


        },
        created: function () {
            this.getRecentLeaves();
        },

    }
</script>
